<template>
  <div class="headerSign">
    <img
      class="logo"
      v-if="companiesConfig && companiesConfig.logo"
      :src="companiesConfig.logo['svg-light']"
      :onload="(logoLoading = true)"
    />
    <div class="inform f14" v-if="guest_periodReport__show && guest_periodReport__show.data">
      <div class="inform_item">
        <div>
          {{ guest_periodReport__show.data['project_data']['project_name'] || '' }}
        </div>
      </div>
      <div class="inform_item">
        <div>
          {{
            guest_periodReport__show.data['project_data']['street'] +
              ', ' +
              guest_periodReport__show.data['project_data']['zip'] +
              ', ' +
              guest_periodReport__show.data['project_data']['city'] || ''
          }}
        </div>
      </div>
      <div class="inform_item">
        <div>
          {{
            $formatDate(guest_periodReport__show.data['period_data']['start_date']) +
              ' - ' +
              $formatDate(guest_periodReport__show.data['period_data']['end_date']) +
              ' Vk ' +
              showSelectedWeeks || ''
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderSign',
  components: {},
  data: () => ({}),
  computed: {
    ...mapGetters('guest_periodReport', ['guest_periodReport__show']),
    ...mapGetters(['companiesConfig']),
    selectedDates() {
      let obj = {}
      obj.dates = this.$getDates(
        new Date(this.guest_periodReport__show.data['period_data']['start_date']),
        new Date(this.guest_periodReport__show.data['period_data']['end_date']),
      )
      obj.weeks = []
      for (let date of obj.dates) {
        if (!obj.weeks.find((i) => i === date.getWeek())) obj.weeks.push(date.getWeek())
      }
      return obj
    },
    showSelectedWeeks() {
      let string = ''
      if (this.selectedDates.weeks) {
        for (let week in this.selectedDates.weeks) {
          if (week == 0) {
            string = string + this.selectedDates.weeks[week]
          } else {
            string = string + ', ' + this.selectedDates.weeks[week]
          }
        }
      }
      return string
    },
  },
}
</script>

<style lang="scss" scoped>
.headerSign {
  width: 100%;
  min-height: 60px;
  height: max-content;
  background: #277faf;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  align-content: center;
  gap: 15px;
  .logo {
    width: auto;
    height: 46px;
    max-width: 125px;
  }
}
.inform {
  width: 100%;
  display: flex;
  column-gap: 100px;
  row-gap: 5px;
  color: #f2f2f2;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  &_item {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
  }
}
</style>
